import React from 'react';
import { SHYFT_EMBLEM } from '@/constants/logoAssets';
import heroDesktop from '@/assets/hero_desktop.jpg';
import heroMobile from '@/assets/hero_mobile.jpg';
import './HeroSection.css';

/* ============================================================
   GoldStar — kept as a named export because HighlightsSection
   imports it. Everything else is new.
   ============================================================ */
export const GoldStar = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    style={{ display: 'inline-block', verticalAlign: 'middle', marginBottom: 2 }}
  >
    <defs>
      <linearGradient id="gsL" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F0D878" />
        <stop offset="50%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#9C7B2C" />
      </linearGradient>
    </defs>
    <path
      d="M12 2 L13.8 8.2 L20 8.2 L15 12 L17 18 L12 14.5 L7 18 L9 12 L4 8.2 L10.2 8.2 Z"
      fill="url(#gsL)"
    />
  </svg>
);

/* ============================================================
   HERO SECTION — photorealistic penthouse scene with
   invitation-style overlay typography and gold CTA.
   ============================================================ */
const HeroSection = () => {
  return (
    <section className="hero" data-testid="hero-section">
      {/* Cinematic photorealistic background */}
      <picture className="hero__bg" aria-hidden="true">
        <source media="(max-width: 768px)" srcSet={heroMobile} />
        <img
          src={heroDesktop}
          alt=""
          loading="eager"
          fetchpriority="high"
          data-testid="hero-bg-image"
        />
      </picture>

      {/* Directional gradient — keeps the typography legible without
          a heavy opaque wash over the whole image. */}
      <div className="hero__overlay" aria-hidden="true" />

      <div className="hero__content" data-testid="hero-content">
        {/* Brand lockup — logo + wordmark, restrained */}
        <div className="hero__brand-row" data-testid="hero-brand">
          <img className="hero__logo" src={SHYFT_EMBLEM} alt="SHYFT Coalition emblem" />
          <div className="hero__brand">SHYFT Coalition</div>
        </div>

        {/* Eyebrow */}
        <div className="hero__eyebrow" data-testid="hero-eyebrow">
          2nd Annual
        </div>

        {/* Event title — "2nd Annual Penthouse Christmas Party" */}
        <h1 className="hero__title" data-testid="hero-title">
          <span className="hero__title-penthouse">Penthouse</span>
          <span className="hero__title-script">Christmas</span>
          <span className="hero__title-party">Party</span>
        </h1>

        {/* Gold divider */}
        <div className="hero__divider" aria-hidden="true">
          <span>✦</span>
        </div>

        {/* Venue */}
        <div className="hero__venue" data-testid="hero-venue">
          The Penthouse @ MET Atlanta
        </div>

        {/* Date / time */}
        <div className="hero__meta" data-testid="hero-meta">
          Saturday, December 12 · 6:00 PM – Until
        </div>

        {/* Display tag — not clickable, keeps the gold pill treatment */}
        <div
          className="hero__cta hero__cta--display"
          data-testid="hero-cta"
          aria-label="Exclusive"
        >
          <em>Exclusive Event</em>
        </div>
      </div>

      <div className="hero__hairline" aria-hidden="true" />
    </section>
  );
};

export default HeroSection;
